import { buildSiteFromApiResult } from 'app/site-detail/services/api/build-site-from-api-result';
import { SiteListItemApiResult, SitesPageApiResult } from 'app/site-detail/services/api/site-api-result.types';

import { SiteListSite, SitesPage, SitesRequest, SITES_START_OFFSET } from '../models/site-list';
import { SiteListResourceRequest, SiteListState } from '../resource/site-list-resource.types';

interface SiteListLoadMoreState {
    readonly error: unknown;
    readonly isLoading: boolean;
    readonly loadedCount: number;
    readonly request: SitesRequest;
    readonly totalCount: number;
}

export function toSitesRequest(request: SiteListResourceRequest): SitesRequest {
    return {
        offset: request.offset,
        limit: request.limit,
        keyword: request.keyword,
        searchToken: request.searchToken,
    };
}

export function toSitesPage(response: SitesPageApiResult): SitesPage {
    return {
        totalCount: response.count,
        results: response.results.map(buildSiteListSiteFromApiResult),
    };
}

export function buildSiteListSiteFromApiResult(apiResult: SiteListItemApiResult): SiteListSite {
    return {
        ...buildSiteFromApiResult(apiResult),
        deviceCount: apiResult.deviceCount ?? null,
        availability: apiResult.availability ?? null,
    };
}

export function isCurrentSiteSearch(request: SitesRequest, keyword: string): boolean {
    return request.keyword === keyword;
}

export function matchesSiteSearch(state: SiteListState, request: SitesRequest): boolean {
    return state.keyword === request.keyword && state.searchToken === request.searchToken;
}

export function shouldReplaceSiteItems(state: SiteListState, request: SitesRequest): boolean {
    return request.offset === SITES_START_OFFSET || !matchesSiteSearch(state, request);
}

export function mergeSiteItems(
    currentItems: readonly SiteListSite[],
    nextItems: readonly SiteListSite[],
): readonly SiteListSite[] {
    const itemsById = new Map(currentItems.map((site) => [site.id, site]));

    for (const site of nextItems) {
        itemsById.set(site.id, site);
    }

    return [...itemsById.values()];
}

export function canLoadMoreSites(state: SiteListLoadMoreState): boolean {
    return (
        !state.isLoading &&
        state.error === undefined &&
        state.loadedCount > 0 &&
        state.loadedCount < state.totalCount &&
        state.request.offset !== state.loadedCount
    );
}
